export default __webpack_public_path__ + "static/media/purchase-ddl-arrow.05a2d42f.svg";